import { useSelector } from "react-redux";
import { getCategoryFooterDescription } from "../../state/modules/category";
import CategoryFooterDescription from "./CategoryFooterDescription";

const CategoryFooterDescriptionContainer = () => {
  const description = useSelector(getCategoryFooterDescription);

  return <CategoryFooterDescription description={description} />;
};

export default CategoryFooterDescriptionContainer;
